import VolumeStatus from './Constants/VolumeStatus';
import IVolume      from './Interfaces/IVolume';

class Volume implements IVolume {
    public level:          number  = Volume.DEFAULT_LEVEL;
    public preMuteLevel:   number  = 0; // Level to restore after unmute
    public volumeStatus:   VolumeStatus = VolumeStatus.AUDIBLE;
    public isSliderActive: boolean = false;

    public static MAX_VOLUME_PERCENT = 110;

    public get isZero(): boolean {
        return this.level === 0;
    }

    public get isLow(): boolean {
        return !this.isZero && this.level < (1 / 3);
    }

    public get isMedium(): boolean {
        return !this.isZero && !this.isLow && this.level < (2 / 3);
    }

    public get isHigh(): boolean {
        return !this.isZero && !this.isLow && !this.isMedium;
    }

    public get isMuted(): boolean {
        return this.volumeStatus === VolumeStatus.MUTED;
    }

    public get isForceMuted(): boolean {
        return this.volumeStatus === VolumeStatus.FORCE_MUTED;
    }

    public get isMutedOrForceMuted(): boolean {
        return this.isMuted || this.isForceMuted;
    }

    public get isAudible(): boolean {
        return this.volumeStatus === VolumeStatus.AUDIBLE;
    }

    public get bottom(): number {
        return this.level * 100;
    }

    public get humanReadableVolumeLevel(): string {
        return Math.round(this.level * Volume.MAX_VOLUME_PERCENT).toString() + '%';
    }

    public get canShowLowVolumeBar(): boolean {
        return this.isLow || this.isMedium || this.isHigh;
    }

    public get canShowMediumVolumeBar(): boolean {
        return this.isMedium || this.isHigh;
    }

    public get canShowHighVolumeBar(): boolean {
        return this.isHigh;
    }

    public static DEFAULT_LEVEL = 0.681;
}

export default Volume;